module.exports = __webpack_public_path__ + "img/CuandoVisitar.8d43ffe4.svg";